export default __webpack_public_path__ + "static/media/ItalianAntipasto.078494df.jpg";